import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNotification } from '@starjack/features/notifications';
import { CashDesk } from '@/models/cashDesk';
import { useDeleteCashDeskMutation } from '@/api/v2/cashDesk';

type CashDeskDeleteDialogProps = {
    cashDesk: CashDesk;
    open: boolean;
    onClose: () => void;
};

export const CashDeskDeleteDialog: FunctionComponent<
    CashDeskDeleteDialogProps
> = ({ cashDesk, open, onClose }) => {
    const [deleteCashDesk, { isLoading }] = useDeleteCashDeskMutation();
    const { addNotification } = useNotification();

    const onDeleteCashDesk = () => {
        deleteCashDesk(cashDesk)
            .unwrap()
            .then(() => {
                addNotification({
                    message: 'Kasse erfolgreich gelöscht',
                    type: 'success',
                });
            })
            .catch(() => {
                addNotification({
                    message:
                        'Fehler beim Löschen. Bitte später noch einmal versuchen',
                    type: 'error',
                });
            })
            .finally(() => {
                onClose();
            });
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Kasse löschen</DialogTitle>
            <DialogContent>
                {!!cashDesk && (
                    <DialogContentText>
                        Soll die Kasse{' '}
                        <Typography sx={{ fontWeight: 600 }} component='span'>
                            {cashDesk.username}
                        </Typography>{' '}
                        wirklich gelöscht werden?
                    </DialogContentText>
                )}
            </DialogContent>

            <DialogActions>
                <Stack spacing={2} direction='row'>
                    <Button onClick={onClose}>Abbrechen</Button>
                    <LoadingButton
                        onClick={onDeleteCashDesk}
                        variant='contained'
                        loading={isLoading}
                    >
                        Löschen
                    </LoadingButton>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
